"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSupportedTokenType = void 0;
function isSupportedTokenType(token) {
    return typeof token === "string" && ["DPoP", "Bearer"].includes(token);
}
exports.isSupportedTokenType = isSupportedTokenType;
//# sourceMappingURL=ISessionInfo.js.map